export default __webpack_public_path__ + "static/media/2.9c2858ac.jpg";